"use client";

import { useEffect } from "@tiendanube/nube-sdk-react-runtime";
import { DrawerContent } from "../drawer-content";
import { FloatingCorners } from "../floating-corner";
import { ModalContent, type ModalContentProps } from "../modal-content";

export type RuntimeProps = ModalContentProps;

function setThemeClass() {
	const theme = window.nubeSDK?.getState()?.store?.theme;
	if (!theme) return;
	document.body.classList.add(`js-nubesdk-theme-${theme}`);
}

export function Runtime({ hostId }: RuntimeProps) {
	useEffect(() => {
		if (document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", setThemeClass);
		} else {
			setThemeClass();
		}
	}, []);

	return (
		<>
			<ModalContent hostId={hostId} />
			<DrawerContent hostId={hostId} slotId="drawer_left" />
			<DrawerContent hostId={hostId} slotId="drawer_right" />
			<FloatingCorners />
		</>
	);
}
